import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import container from './container.js'
import expanded from './expanded.js'

export default contract({
  container: array([
    container
  ]),
  expanded: array([
    expanded
  ])
})